import React, { useRef, useState, useEffect } from "react";
import { Play, Pause, Music } from "lucide-react";
import { themeSong } from "../mock";
import Reveal from "./Reveal";

const ThemeSong = () => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    const onEnd = () => setPlaying(false);
    a.addEventListener("ended", onEnd);
    return () => a.removeEventListener("ended", onEnd);
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.play();
      setPlaying(true);
    }
  };

  return (
    <section
      className="py-16 md:py-24 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #187EE4 0%, #2f93f2 100%)" }}
    >
      <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
        <Reveal>
          <div className="inline-flex items-center gap-2 text-white/90 font-display text-sm tracking-widest uppercase mb-3">
            <Music className="w-5 h-5" /> Sing Along
          </div>
          <h2 className="font-display text-white text-3xl md:text-5xl brave-shadow-text">
            {themeSong.title}
          </h2>
          <p className="mt-4 text-white/90 text-lg font-semibold">{themeSong.subtitle}</p>

          <div className="mt-9 relative mx-auto max-w-2xl rounded-3xl overflow-hidden shadow-2xl ring-4 ring-white/40">
            <img src={themeSong.image} alt="Brave Me characters" className="w-full h-auto block" data-testid="theme-song-image" />
            <button
              onClick={toggle}
              className="absolute inset-0 flex flex-col items-center justify-center gap-3 group"
              aria-label={playing ? "Pause theme song" : "Play theme song"}
              data-testid="theme-song-play-button"
            >
              <span className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition-colors" />
              <span
                className="relative flex items-center justify-center w-20 h-20 md:w-24 md:h-24 rounded-full shadow-2xl transition-transform group-hover:scale-110"
                style={{ backgroundColor: "#FF6C10" }}
              >
                {playing ? (
                  <Pause className="w-10 h-10 text-white" fill="white" strokeWidth={0} />
                ) : (
                  <Play className="w-10 h-10 text-white ml-1" fill="white" strokeWidth={0} />
                )}
              </span>
              <span className="relative font-display text-white text-xl md:text-2xl brave-shadow-text">
                Brave Me Theme Song
              </span>
            </button>
          </div>

          <audio ref={audioRef} src={themeSong.audio} preload="metadata" />
        </Reveal>
      </div>
    </section>
  );
};

export default ThemeSong;
